import React from 'react';
import { css } from 'styled-components';
import { Field } from 'react-final-form';
import FontStyles from 'constants/font-styles';
import Colors from 'constants/colors';
import i18n from 'i18n';
import { applyStyles } from 'util/helpers';
import CustomMedia from 'util/custom-media-query';
import SelectContainer from 'components/common/SelectField/components/SelectContainer';
import moment from 'moment';

const CurrentYear = moment().year();

const ExpiresField = ({ className }) => (
  <div className={className}>
    <label>
      <span>{i18n.t('orderAggregators:payment:payment.card.expires')}</span>
      <i className="tag">{i18n.t('common:required')}</i>
    </label>
    <div className="expires-container">
      <Field
        name="payment.expiresMonth"
        render={({ input, meta }) => (
          <React.Fragment>
            <div className="expires-month">
              <SelectContainer
                name="payment.expiresMonth"
                input={input}
                meta={meta}
                autoComplete="cc-exp-month"
                inputProps={{
                  options: [...Array(12).keys()].map(i => ++i)
                }}
              />
            </div>
            <span className="suffix">{i18n.t('common:monthSuffix')}</span>
          </React.Fragment>
        )}
      />
      <Field
        name="payment.expiresYear"
        render={({ input, meta }) => (
          <React.Fragment>
            <div className="expires-year">
              <SelectContainer
                name="payment.expiresYear"
                input={input}
                meta={meta}
                autoComplete="cc-exp-year"
                inputProps={{
                  options: [...Array(10).keys()].map(i => CurrentYear + i)
                }}
              />
            </div>
            <span className="suffix">{i18n.t('common:yearSuffix')}</span>
          </React.Fragment>
        )}
      />
    </div>
  </div>
);

const commonStyle = css`
  margin: 40px 0;

  label {
    ${FontStyles.text5}

    display: flex;
    color: ${Colors.black1};
    align-items: center;

    span {
      display: block;
    }
  }

  .tag {
    ${FontStyles.text11}
    display: block;
    width: 38px;
    height: 22px;
    line-height: 22px !important;
    background-color: ${Colors.orange1};
    color: ${Colors.white1};
    text-align: center;
    font-style: normal;
    border-radius: 4px;
  }

  .expires-container {
    display: flex;
    justify-content: left;
    align-items: center;

    .expires-month {
      margin-right: 8px;
    }

    .expires-year {
      margin-right: 8px;
      margin-left: 16px;
    }
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  label {
    margin: 0 0 12px 0;

    span {
      margin-right: 8px;
    }
  }

  .expires-month {
    width: 58px;
  }

  .expires-year {
    width: 74px;
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  padding: 0 16px;
  width: 100%;

  label {
    margin: 0 0 12px 0;

    span {
      margin-right: 4px;
    }
  }

  .expires-month {
    width: 64px;
  }

  .expires-year {
    width: 82px;
  }
`;

export default applyStyles(ExpiresField)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/Payment/components/ExpiresField.js